//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MembershipModal',
  methods: {
    handleEsc() {
      this.$modal.hide('membership');
    },
  },
};
